export const CLOSE_DELAY_MS = 1000;
export const REWARD_MODAL_TRANSITION_MS = 220;
export const CASH_GIFT_SELECTION_FEEDBACK_MS = 720;
export const CASH_GIFT_EFFECTS_FADE_MS = 150;
export const CASH_GIFT_GUIDE_DURATION_MS = 1500;
export const CASH_GIFT_GUIDE_DISMISS_MS = 320;
export const PROGRESS_SETTLED_EMPHASIS_MS = 900;
export const ENTRY_CASH_GIFT_MASK_FADE_MS = 300;
export const MODAL_STORAGE_KEY = 'refer-earn-spin-guide-dismissed';

export const DEFAULT_REWARD_VALUES = [
  '0-200',
  '279',
  '379',
  '579',
  '779',
  '979',
  '1279',
  '1479',
  '1500',
];

export const DEFAULT_REWARD_AMOUNT_VALUES = [
  200, 279, 379, 579, 779, 979, 1279, 1479, 1500,
];

export const INITIAL_FREE_SPIN_COUNTDOWN_SECONDS = 5 * 3600 + 30 * 60 + 17;
export const INITIAL_CLAIM_COUNTDOWN_SECONDS =
  8 * 24 * 3600 + 15 * 3600 + 48 * 60 + 42;
export const OPEN_ROUND_CLAIM_COUNTDOWN_SECONDS = 15 * 24 * 3600;

export const getWheelRules = (targetAmount?: number) => {
  const normalizedTargetAmount = Number(targetAmount);
  const targetAmountText = Number.isFinite(normalizedTargetAmount)
    ? normalizedTargetAmount.toLocaleString('en-US')
    : '-';

  return [
    `Once your accumulated balance reaches ${targetAmountText} ${currencyName.toLowerCase()}, you can apply for a withdrawal.`,
    'The promotion lasts for three days. After the promotion ends, the accumulated bonus will be reset and the promotion will restart.',
    'Each user can enjoy one free spin per day, and the number of spins resets daily at 24:00.',
    'Once your application is approved, the bonus will be directly deposited into your wallet.',
    'This bonus must be doubled once before the user can claim it.',
    "The invitee must link their mobile phone number and the inviter's invitation code for the promotion to be considered a winner.",
    'Please refrain from using unfair means to obtain bonuses. We will sanction any improper behavior without prior notice.',
    'To avoid misunderstandings, we reserves the right to final interpretation of this promotion and reserves the right to change or cancel the promotion. If you have any questions, please contact our 24-hour customer service.',
  ];
};

export const withdrawalTickerMessages = [
  `Player***001 success withdrawal ${defaultCurrencySymbol} 1,500.00`,
  `Player***018 success withdrawal ${defaultCurrencySymbol} 1,500.00`,
  `Player***127 success withdrawal ${defaultCurrencySymbol} 1,500.00`,
  `Playup***236 success withdrawal ${defaultCurrencySymbol} 1,500.00`,
  `Probet***452 success withdrawal ${defaultCurrencySymbol} 1,500.00`,
];

export const WITHDRAW_TARGET_AMOUNT = 1500;

export const IDLE_LIGHT_DURATION_MS = 3600;
export const SPINNING_LIGHT_DURATION_MS = 700;
export const REQUEST_TIMEOUT_MS = 3000;
export const USE_MOCK_WHEEL_SPIN = false;
export const WHEEL_STATUS_POLL_INTERVAL_MS = 10000;
export const WHEEL_BROADCAST_POLL_INTERVAL_MS = 60000;
export const CRUISE_ROTATIONS = 1.6;
export const SPIN_ACCEL_DURATION_MS = 450;
export const SPIN_START_DEG_PER_MS = 0.28;
export const SPIN_FAST_DEG_PER_MS = 1.38;
export const SUCCESS_EASE_EXTRA_ROTATIONS = 1.25;
export const FALLBACK_EASE_EXTRA_ROTATIONS = 0.85;
export const SUCCESS_EASE_DURATION_MS = 1400;
export const FALLBACK_EASE_DURATION_MS = 1100;
export const DEFAULT_FALLBACK_TARGET_INDEX = 0;
export const POINTER_TARGET_ANGLE_DEG = -90;
export const SHOW_WHEEL_ALIGNMENT_GUIDES = false;
export const INITIAL_WHEEL_ROTATION_DEG = 0;
export const ROTATING_LAYER_STYLE = {
  left: '9%',
  top: '13%',
  width: '81.8%',
  height: '69.4%',
};
export const REWARD_START_DEG = -90;
export const REWARD_STEP_DEG = 360 / DEFAULT_REWARD_VALUES.length;
export const LIGHT_ANGLE_SECTIONS = [
  {key: 'rightUpper', startDeg: -50, endDeg: -10, count: 2},
  {key: 'rightLower', startDeg: 30, endDeg: 70, count: 2},
  {key: 'leftLower', startDeg: 110, endDeg: 150, count: 2},
  {key: 'leftUpper', startDeg: 190, endDeg: 230, count: 2},
] as const;
import {currencyName, defaultCurrencySymbol} from '@/config';
